import { Radio as MuiRadio, RadioProps } from "@mui/material";

type Props = RadioProps;

export const Radio = ({ ...props }: Props) => {
  return <MuiRadio {...props} />;
};
